import React from 'react';
//import { toJS } from 'mobx';
import { observer } from 'mobx-react';
import { createViewModel } from 'mobx-utils';
import Dropzone  from 'react-dropzone';
import { TextField, Dialog, DialogTitle, DialogContent, Typography,
         Divider, LinearProgress } from '@mui/material';
import { Autocomplete, Alert } from '@mui/material';
import { Navigate } from 'react-router';
import styled from 'styled-components';
import ReCAPTCHA from 'react-google-recaptcha';

import QuickEditDialog from './QuickEditDialog';
import Header from './Header';
import { AppStates, IngestStates } from './FlowStore';

const StyledFormGroup = styled.div`
  margin: 30px 30px;
  visibility: ${props => (props.ready ? 'visible' : 'hidden')};
`;

const StyledAttorneySelectGroup = styled.div`
  margin: 30px 30px;
`;

const StyledMainContent = styled.div`
  font-size: 12pt;
  flex-grow: 1;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
`;

const MainForm = styled.div`
  border: none;
  padding-bottom: 300px;
`;

const PageContainerDiv = styled.div`
  display: flex;
  flex-direction: column;
  width: 100vw;
  height: 100vh;
`;

const getColor = (props) => {
  if (props.isDragAccept) {
    return 'rgb(0,255,0,.2)';
  }
  if (props.isDragReject) {
    return 'rgb(255,0,0,.2)';
  }
  if (props.isDragActive) {
    return 'rgb(0,255,0,.2)';
  }
  return 'whitesmoke';
}

const StyledDropDiv = styled.div`
  height: 100px;
  border-radius: 5px;
  margin-top: 20px;
  border-width: 1px;
  border-style: dashed;
  background-color: ${props => getColor(props)};
`;

const StyledTextField = styled(TextField)`
  font-size: 8pt;
`;

// const activeStyle = {
//   border: '2px dashed ' + Colors.GREEN2
// };

// const rejectStyle = {
//   border: '2px dashed ' + Colors.RED2
// };

const Dashboard = observer((props) => {
  const store = props.store;
  const [attyEditDisabled, setAttyEditDisabled] = React.useState(!store.isAttorneySelected());
  const [overlayIsOpen, setOverlayIsOpen] = React.useState(false);
  // this is a key that is touched to force autocomplete to redraw
  const [attyValue, setAttyValue] = React.useState(null);
  const [atty, setAtty] = React.useState(null);  // this is the selected attorney
  const [uploadErrorOpen, setUploadErrorOpen] = React.useState(false);
  const [uploadErrorMessage, setUploadErrorMessage] = React.useState("");

  React.useEffect(() => {
    // When we mount, we are (1) brand new, (2) a refresh, or (3) a reload, such as after an error
    // or a later session.  In case (3) we have persisted store and we need to bring the server
    // into sync, which we do at a minimum by setting the attorney on the server
    console.log('Mounted Dashboard ' + props.refresh + ' atty:' + store.attorney);
    if (props.refresh) {
      store.refresh();
    }
    if (!atty && store.attorney) {
      // FIXME:
      console.log('***', atty, store.attorney);
      //setAtty(createViewModel(store.availableAttorneys[store.attorney]));
      setAtty(store.availableAttorneys[store.attorney]);
    }
    // FIXME:  right now we do this once the store is hydrated
    //else if (this.store.isAttorneySelected()) {
    //  console.log('Synching attorney');
    //  this.store.setAttorney(this.store.attorney);
    //}
    store.listWorkspaces();
  }, []);

  const processFile = file => {
    //if (this.props.doc.socketConnected) {
    //this.props.resetDoc();
    store.resetWorkspace('');
    //this.props.app.setState(() => ({ uiState: 'dashboard' }));
    toggleOverlay();
    //this.store.ingestState = IngestStates.LOADING;
    //setTimeout(() => this.store.ingestFile(file), 5000);
    store.ingestFile2(file);
    //}
  };

  const onDropPTO = (acceptedFiles, rejectedFiles) => {
    if (acceptedFiles.length === 1) {
      const file = acceptedFiles[0];
      console.log("Accepted for upload: ", file.name, file.path);
      processFile(file);
    }
    if (rejectedFiles.length > 0 || acceptedFiles.length > 1) {
      showFailDialog('file_reading_error'); 
    }
  };

  const noDrop = () => {
    showFailDialog('upload_disabled');
  };

  const showFailDialog = errorType => {
    console.log(errorType);
    let msg = "Error uploading file";
    if (errorType === 'file_reading_error')
      msg = "Please try again with a single PDF";
    else if (errorType === 'upload_disabled')
      msg  = "File uploading not enabled in Demo version.  Please select a pre-loaded document to work on, below.";
    setUploadErrorOpen(true);
    setUploadErrorMessage(msg);
  };

  const showSuccessToaster = () => {
  };

  // const onInputPTO = e => {
  //   e.preventDefault();
  //   const file = e.target.files[0];
  //   console.log(file);
  //   if (file && file.type === 'application/pdf') {
  //     processFile(file);
  //   } else {
  //     showFailDialog('file_reading_error');
  //   }
  // };

  const toggleOverlay = () => {
    setOverlayIsOpen((previous) => !previous.overlayIsOpen);
    //this.setState(prevState => ({ overlayIsOpen: !prevState.overlayIsOpen }));
  };

  const preventHandler = (e) => {
    if (!store.isAttorneySelected())
      e.preventDefault();
    //e.preventPropagation();
  };

  const wsLabel = (ws) => {
    //console.log('label', toJS(ws));
    let tag = '(Pat)';
    if (ws.doctype.doc_type.substring(0,3) === 'PCT')
      tag = '(PCT)';
    else if (ws.doctype.doc_type.substring(0,2) === 'TM')
      tag = '(TM)';
    return ws.matter.num + ' -- ' +
      store.docTypes[ws.doctype.doc_type] + ' ' + tag;
  };

  const onChange = (value) => {
    console.log("Captcha value", value);
    store.captchaPassed = true;
  };
  
  if (store.isFreeDemo() && !store.captchaPassed)
    return (
      <div style={{height: '90vh', display: 'flex',
                   flexDirection: 'column', alignItems: 'center', justifyContent: 'center'}}>
        <div style={{width: '40vw', marginBottom: '1em'}}>
          <Typography>
            Welcome to the PTOFlow demo site.  You will not be able to upload new documents,
            but you can experiment with the features for a variety of preloaded documents.
          </Typography>
        </div>
        <ReCAPTCHA
          sitekey="6LdsarcZAAAAAGKqK8mRxFvPJSyDbQ3cIgpj6y8Q"
          onChange={(value) => onChange(value)}
        />
      </div>);

  // uiState is changed once old workspace is loaded
  if (store.appState === AppStates.REVIEW) {
    console.log('Redirecting to /review');
    return <Navigate to="/review" />;
  }

  if (store.appState === AppStates.GENDOCS) {
    return <Navigate to='/genDocs' />;
  }
  
  return (
    <PageContainerDiv
      onDragOver={preventHandler}
      onDrop={preventHandler} >
      <Header store={store}/>
      
      <Dialog
        open={uploadErrorOpen}
        onClose={()=>setUploadErrorOpen(false)} >
        <DialogContent>
          <Alert severity="error">
            {uploadErrorMessage}
          </Alert>
        </DialogContent>
      </Dialog>

      <Dialog
        open={overlayIsOpen}  >
        <DialogTitle>Document Status</DialogTitle>
        <Divider />
        <DialogContent>
          <Typography variant="body1"  style={{fontWeight: 'bold', marginBottom: 10}}>
            Hold on, we are processing your document.
          </Typography>
          <Typography variant="body2" style={{marginBottom: 10}}>Uploading document ...</Typography>
          {/* <LinearProgress
             color={this.store.ingestState >= IngestStates.EXPLODING ? 'primary' : 'secondary'}
             variant={this.store.ingestState < IngestStates.EXPLODING ? 'indeterminate' : 'determinate'}
             value={100}
             />*/}
          <LinearProgress
            color={store.ingestState >= IngestStates.EXPLODING ? 'primary' : 'secondary'}
            variant='determinate'
            value={100 * store.percentComplete}
          />
          
          <Typography variant="body2" style={{marginTop: 10, marginBottom: 10}}>Exploding PDF ...</Typography>
          <LinearProgress
            color={store.ingestState >= IngestStates.OCRING ? 'primary' : 'secondary'}
            variant={store.ingestState === IngestStates.EXPLODING ? 'indeterminate' : 'determinate'}
            value={store.ingestState >= IngestStates.EXPLODING ? 100 : 0}
          />
          
          <Typography variant="body2" style={{marginBottom: 10, marginTop: 10}}>OCR-ing your document ...</Typography>
          <LinearProgress
            style={{marginBottom: 20}}
            color={store.ingestState === IngestStates.DONE ? 'primary' : 'secondary'}
            variant='determinate'
            value={100 * store.ocrPageCount / store.numPages || 0}
          />
        </DialogContent>
      </Dialog>
      
      <StyledMainContent>
        <MainForm>
          <StyledAttorneySelectGroup>
            <Typography variant='body1' style={{fontWeight: 500}}>First, select an attorney:</Typography>
            <div style={{display:'flex', alignItems:'flex-end'}}>
              <Autocomplete
                style={{flexGrow: 1, marginRight: 10}}
                size='small'
                id='attorney-selection'
                key={attyValue}
                value={store.getAttorney(store.attorney)}
    //defaultValue={this.store.isAttorneySelected() ?
    //              this.store.availableAttorneys[this.store.attorney] : null}
                options={Object.values(store.availableAttorneys)}
                getOptionLabel={(o) => {
                  return o ? o.id + ': ' + o.name : 'Foobar';
                }}
                onChange={(e, newValue) => {
                  if (newValue) {
                    console.log("Selecting atty", newValue.id);
                    store.setAttorney(newValue.id);
                    setAttyEditDisabled(false);
                    setAtty(createViewModel(newValue));
                  }
                }}
                renderInput={(params) => {
                  return (
                    <TextField {...params} style={{marginBottom:0}} label={'Select Attorney'}
                               variant='outlined' size='small' margin='dense'
                    />
                  );
                }}
              />
              <QuickEditDialog
                title={"Edit/View Attorney " + store.attorney}
                record={atty}
                fields={['id', 'name', 'firm', 'email', 'phone', 'reg_num', 'deposit_acct']}
                getFieldLabel={(field) => store.attorneyAttributeNames[field]}
                onSave={(record) => {
                  console.log('Saving atty info:', record.isDirty, record.name);
                  if (!record.isDirty) {
                    console.log('Atty not dirty');
                    return;
                  }
                  // Make a copy, copy fields from modified record into copy, and update
                  let newAtty = {...store.availableAttorneys[store.attorney]};
                  for (var k in newAtty)
                    newAtty[k] = record[k];
                  store.updateAttorneys(newAtty);
                  store.setAttorney(newAtty.id);
                  setAttyValue(record.id + ': ' + record.name);
                }}
                disabled={attyEditDisabled}
              />
              {/*
                 <NavLink to="/admin">
                 <Button variant='outlined'>Edit</Button>
                 </NavLink>
               */}
            </div>
          </StyledAttorneySelectGroup>

          <StyledFormGroup
            className="pt-form-group"
            ready={true}
          >
            <Typography variant='body1' style={{fontWeight:500}}>
              Next, upload the document you received from the Patent Office:
            </Typography>

            { !store.isAttorneySelected() ?
              <StyledDropDiv> 
                <Typography variant='body2'>Please select attorney first</Typography>
              </StyledDropDiv>
              :
              <Dropzone
                onDrop={store.isFreeDemo() ? () => showFailDialog('upload_disabled') : onDropPTO}
                accept={{'application/pdf': ['.pdf']}}>
                {({getRootProps, getInputProps, isDragActive, isDragAccept, isDragReject}) => (
	          <section>
	            <StyledDropDiv 
	              {...getRootProps({isDragActive, isDragAccept, isDragReject})}>
                      <Typography variant='body2'>
                        {store.isAttorneySelected() ?
                         (<span><input{...getInputProps()}/>                      
             Drop your document here, or click to select file</span>) :
                         <span>Please select attorney first</span>
                        }
                      </Typography>
	            </StyledDropDiv>
	          </section>
                )}
              </Dropzone>}

          </StyledFormGroup>
          <StyledFormGroup
            className="pt-form-group"
            ready={true}
          >
            <Typography variant='body1' style={{fontWeight: 500}}>Or, work on a prior document:</Typography>
            <Autocomplete
              style={{width: "100%", display: 'inline-block'}}
              size='small'
              id='workspace-selection'
              disabled={!store.isAttorneySelected()}
              value={store.isAttorneySelected() ? store.getWorkspace(store.workspace) : null}
              options={store.oldWorkspaces}
              getOptionLabel={(ws) => {
                return store.isAttorneySelected() ? wsLabel(ws) : "Select Workspace";
              }}
              onChange={(e, newValue) => {
                if (newValue) {
                  store.workspace = newValue.ws;
                  store.loadWorkSpace(newValue.ws);
                  store.appState = AppStates.REVIEW;
                  console.log("Selecting ws",newValue.ws);
                }
              }}
              renderInput={(params) => (
                <StyledTextField
                  {...params}
                  variant='outlined'
                  label={store.isAttorneySelected() ? 'Select Workspace' : 'Select Attorney First'}
                />
              )}
            />
          </StyledFormGroup>
        </MainForm> 
      </StyledMainContent>
      {JSON.stringify(store.sessionInfo())}
    </PageContainerDiv>
  );
});

export default Dashboard;

